export default __webpack_public_path__ + "static/media/wishes.aa2e66cd.webp";